export const ArrayDataToApiListData = <T>(
  array: T[] | undefined | null,
  options?: {
    // Optional: Custom separator (default is comma)
    separator?: string;
    // Optional: Filter function to exclude certain values
    filter?: (item: T) => boolean;
    // Optional: Transform function for each item
    transform?: (item: T) => string;
  },
): string | undefined => {
  // If array is null/undefined/empty, return undefined
  if (!array || !Array.isArray(array) || array.length === 0) {
    return undefined;
  }

  const {
    separator = ',',
    filter = (item: T) => item != null && String(item).trim() !== '',
    transform = (item: T) => String(item).trim(),
  } = options || {};

  // Filter and transform the array
  const processedItems = array.filter(filter).map(transform);

  // If no valid items after filtering, return undefined
  if (processedItems.length === 0) {
    return undefined;
  }

  // Join with separator
  return processedItems.join(separator);
};
